export default __webpack_public_path__ + "static/14-02093f8c9d2a25c152f97b8a929c256f.png";